import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Market } from '../../../api/models/market-model';
import { Organization } from '../../../api/models/organization';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { User } from '../../../api/models/user-model';
import { AuthService } from '../../../api/services/auth.service';
import { MarketService } from '../../../api/services/market.service';
import { ProjectService } from '../../../api/services/project.services';
import { UserService } from '../../../api/services/user.service';

@Component({
  selector: 'app-bom-create',
  templateUrl: './bom-create.component.html',
  styleUrls: ['./bom-create.component.scss']
})
export class BomCreateComponent implements OnInit {

  hasFile = false;
  uploaded = false;
  errorCreatingByFile = false;
  errorMessage: string[] = [];
  //for upload BOM
  marketDropdownSettings;
  roleRequest: RoleRequest;
  isTesscoAdmin: boolean;
  organizations: Organization[] = [];
  allMarkets: Market[] = [];
  marketsFiltered: Market[] = [];
  selectedOrgId = '';
  selectedMarkets = [];
  accountNumber: string;

  constructor(public activeModal: NgbActiveModal,
    private projectService: ProjectService,
    private authService: AuthService,
    private userService: UserService,
    private marketService: MarketService,
  ) { }

  onBomFileUploaded(id: string) {
    this.hasFile = true;
    let selectedMarketIds = [];
    this.selectedMarkets.forEach(sm => selectedMarketIds.push(sm.id));
    this.accountNumber = localStorage.getItem('marketAccountNo');
    this.projectService.createBomByImportFile(id, this.accountNumber, this.selectedOrgId, selectedMarketIds).subscribe(bom => {

      if(bom.errorMessages.length>0){
        this.errorMessage = bom.errorMessages;
        this.errorCreatingByFile = true;
      }else {
        this.activeModal.close(bom);
      }

    }, error => {
      this.errorCreatingByFile = true;
      this.errorMessage.push(error.error.message);
    });
  }

  clearErrorMessage(){
    this.errorMessage = [];
    this.activeModal.close();
  }

  deleteFile() {
    this.hasFile = false;
  }

  createManually() {
    this.activeModal.close('manually');
  }


  ngOnInit() {
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
    });
    forkJoin(this.userService.findUserById(this.authService.getUserId()), this.userService.getOrganizations())
    .subscribe((data: [User, Organization[]]) => {
      let currentOrgId = data[0]['Organization ID'];
      this.selectedOrgId = currentOrgId;
      this.organizations = data[1];
      this.marketService.getMarketsByOrgId(currentOrgId).subscribe(markets => {
        this.allMarkets = markets;
        this.allMarkets = this.allMarkets.filter(mkt => this.userService.isMarketPermittedForCurrentUser(mkt.id));
        this.marketsFiltered = this.allMarkets;
      });
    });

    this.setMarketDropdownSettings();
  }

  setMarketDropdownSettings(){
    this.marketDropdownSettings = {
      singleSelection: false,
      textField: 'name',
      itemsShowLimit: 3,
      enableCheckAll: true,
      idField: 'id',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    }
  }

  changeOrg(organizationId: string) {
    this.selectedOrgId = organizationId;
    this.marketService.getMarketsByOrgId(this.selectedOrgId).subscribe(markets => {
      this.marketsFiltered = markets;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/boms/bom-create/bom-create.component.ts